interface Properties {
  width?: number;
  height?: number;
  color?: string;
  /** Degrees to rotate the (default downward-pointing) triangle. */
  rotate?: number;
}

/** Figma 75644:18062 / 75644:18070 — small dropdown-disclosure triangle. */
const FigmaSmallChevronIcon = ({
  width = 9,
  height = 6,
  color = '#121826',
  rotate = 0,
}: Properties) => (
  <svg
    width={width}
    height={height}
    viewBox='0 0 9 6'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    style={{ transform: rotate ? `rotate(${rotate}deg)` : undefined }}
  >
    <path d='M0 0H9L4.50001 6L0 0Z' fill={color} />
  </svg>
);

export default FigmaSmallChevronIcon;
